import "./Token01.css";

function Token01() {
  return (
    <div class="Token01 section" id="token">
      <div class="container">
        <div class="Token01-box">
          <div>
            <h5>TOKEN</h5>
            <h2>Tokenomics</h2>
            <p>Designed with a focus on community fun and organic growth.</p>
            <div class="btnFlex">
              <a href="" target="_blank" rel="noopener noreferrer">
                <button class="btn01">DEXSCREENER</button>
              </a>
              <a href="" target="_blank" rel="noopener noreferrer">
                <button class="btn01">DEXTOOLS</button>
              </a>
            </div>
          </div>

          <div>
            <div class="ca">
              <h4>CA:</h4>
              <p>0x0000000000000000000000000000000000000000</p>
            </div>
            <div>
              <h4>Symbol:</h4>
              <p>$Zhǐwǔ</p>
            </div>
            <div>
              <h4>Tax:</h4>
              <p>0%</p>
            </div>
            <div>
              <h4>Supply:</h4>
              <p>1,000,000,000</p>
            </div>
            <div>
              <h4>LP:</h4>
              <p>Locked</p>
            </div>
          </div>
        </div>

        <div class="HowTo01-description" id="how">
          <h2>How To Buy ?</h2>
          <p>
            Buying $Zhǐwǔ is easy! Simply use a BSC-compatible wallet like
            Metamask to connect to a decentralized exchange (DEX) like
            PancakeSwap. Search for $Zhǐwǔ, and follow the on-screen
            instructions to complete your purchase.
          </p>
        </div>

        <div class="HowTo01-box">
          <div>
            <h3>Step 1</h3>
            <p>Copy the Contract address from above, or find it on:</p>
            <a href="" target="_blank" rel="noopener noreferrer">
              <button class="btn02">BSCSCAN</button>
            </a>
          </div>
          <div>
            <h3>Step 2</h3>
            <p>Go to a FourMeme or PancakeSwap and paste the CA there.</p>
            <a href="" target="_blank" rel="noopener noreferrer">
              <button class="btn02">FourMeme</button>
            </a>
          </div>
          <div>
            <h3>Step 3</h3>
            <p>
              Make sure you got the right token selected, choose the amount of
              BNB you want to spend and click Confirm.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Token01;
